module.exports = __webpack_public_path__ + "static/media/dashboard.be016f5f.svg";